import React from "react";
import { Stack, Box } from "@mui/material";

// Dialogue bubble styles based on type
const bubbleConfig = {
  sender: {
    backgroundColor: "#DCF8C6",
    borderRadius: "10px 10px 0 10px",
    padding: "10px",
    maxWidth: "70%",
    margin: "5px",
  },
  bot: {
    backgroundColor: "#F0F0F0",
    borderRadius: "10px 10px 10px 0",
    padding: "10px",
    maxWidth: "70%",
    margin: "5px",
  },
  botAlert: {
    backgroundColor: "#d91212ff",
    borderRadius: "10px 10px 10px 0",
    padding: "10px",
    maxWidth: "70%",
    margin: "5px",
  },
};

// Assuming Dialogue is a styled Box component for the bubble
const Dialogue = Box;

const ChatBubble = ({ content }) => {
  //console.log("content ::", content);

  return (
    <Stack
      sx={{
        width: "100%", // Ensure full parent width
        alignItems: content.senderType === "sender" ? "flex-end" : "flex-start",
        justifyContent:
          content.senderType === "sender" ? "flex-end" : "flex-start",
      }}
    >
      <Dialogue
        sx={{
          ...bubbleConfig[content.senderType],
          overflow: "visible",
          boxSizing: "border-box",
          boxShadow: 1, // Material UI shadow for elevation
        }}
      >
        <pre
          style={{
            wordBreak: "break-word",
            whiteSpace: "pre-wrap",
            width: "100%",
            fontWeight: "lighter",
            fontFamily: "inherit",
            margin: 0,
            color: content.senderType === "botAlert" ? "#FFFFFF" : "#292929",
            fontWeight: "500",
          }}
        >
          {content.text}
        </pre>
      </Dialogue>
    </Stack>
  );
};

export default ChatBubble;
